import { bl_fi_sales_contract_folder_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class SalesContractFolderHdrContainerModel extends BaseContainerModel {
    bl_fi_sales_contract_folder_hdr: bl_fi_sales_contract_folder_hdr_RowClass = new bl_fi_sales_contract_folder_hdr_RowClass();
}